
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 40 40"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M29.017 14.217v-4.7a9.017 9.017 0 00-18.034 0v4.7a14.244 14.244 0 009 25.283h.027a14.244 14.244 0 009-25.283zM20 2.81a6.715 6.715 0 016.707 6.707v3.157a14.03 14.03 0 00-13.414 0V9.517A6.715 6.715 0 0120 2.81zm0 10.483a11.949 11.949 0 010 23.9 11.949 11.949 0 010-23.9z"}}),_c('path',{attrs:{"d":"M20 34.259a9.018 9.018 0 000-18.036 9.018 9.018 0 000 18.036zm0-2.311a6.707 6.707 0 116.707-6.707A6.715 6.715 0 0120 31.948z"}}),_c('path',{attrs:{"d":"M21.063 21.7a2.466 2.466 0 00-2.218 4.4v3.073a1.155 1.155 0 102.31 0V26.1a2.467 2.467 0 00-.092-4.405z"}})])
          )
        }
      }
    